/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { CANDY_APPLE, OLAF } from 'HubStyleTokens/colors';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import text from 'I18n/utils/unescapedText';
export default class _class extends Component {
  render() {
    const {
      className,
      fieldErrors,
      i18nKey,
      placement
    } = this.props;
    const errorCount = Object.keys(fieldErrors).reduce((sum, attributeName) => {
      return fieldErrors[attributeName].length + sum;
    }, 0);

    if (!errorCount) {
      return null;
    }

    return /*#__PURE__*/_jsx(UITooltip, {
      placement: placement,
      title: text(i18nKey, {
        count: errorCount
      }),
      children: /*#__PURE__*/_jsx(UIIconCircle, {
        backgroundColor: CANDY_APPLE,
        borderWidth: 0,
        className: className,
        color: OLAF,
        name: "warning",
        padding: 0.2,
        size: 10
      })
    });
  }

}
_class.propTypes = {
  className: PropTypes.string,
  fieldErrors: PropTypes.object,
  i18nKey: PropTypes.string,
  placement: PropTypes.string
};
_class.defaultProps = {
  className: null,
  fieldErrors: {},
  i18nKey: 'DesignEditorsUI.customWidgetEditor.errors.tooltips.fieldError',
  placement: 'top'
};